<template>
    <div class="single-rating">
        <div class="single-rating__top">
            <div class="single-rating__info">
                <div class="single-rating__info--user">
                    <common-user-avatar :user="rating.user" size="medium-small"></common-user-avatar>
                    <div class="single-rating__info--user-data">
                        <div class="single-rating__info--name">{{ rating.user.firstName }} {{ rating.user.lastName }}</div>
                        <div class="single-rating__info--time">{{ createdTime }}</div>
                    </div>
                </div>
                <common-rating-stars :value="rating.ratingScore" type="secondary"></common-rating-stars>
            </div>
        </div>
        <div v-if="rating.comments.length" class="single-rating__comment">
            {{ rating.comments[0].comment }}
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        props: { rating: { type: Object, required: true } },

        computed: {
            createdTime() {
                return dayjs(this.rating.createdAt).format('DD.MM.YYYY HH:mm')
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/rating/_single-rating.scss';
</style>
